export default "__VITE_ASSET__Dura60oP__"